import type { ReactNode } from 'react'

import Footer from '@/legacy-src/components/footer/Footer'
import { PromotionsBarPagesRouter } from '@/legacy-src/components/promotionsBar/PromotionsBarPagesRouter'
import SupportWidget from '@/legacy-src/components/support/SupportWidget'

import { useCMSMenu } from '@/src/domains/cms-menus/hooks/useCMSMenu'
import { Header } from '@/src/domains/header/components/Header'

export interface LayoutPublicPagesProps {
  children: ReactNode
}

export const LayoutPublicPages = ({ children }: LayoutPublicPagesProps) => {
  const { data: mainMenu } = useCMSMenu('main-menu')
  const { data: otherMenu } = useCMSMenu('other-menu')

  return (
    <div className="flex min-h-dvh flex-col">
      <PromotionsBarPagesRouter />
      <Header menu={mainMenu} />
      <div className="flex grow flex-col">{children}</div>
      <Footer menu={otherMenu} />
      <SupportWidget />
    </div>
  )
}
